import { DistributionReason, TaxWithholdingTypes } from '@Types'
import {
  TransferRecurrences,
  WhenToSend,
  TransferFrequency,
  RecurringTransferFrequency
} from '../../components/TransferFrequency/Types'
import { TransferFeesType } from '../../components/TransferFees/types'

interface Recipients {
  'ACCOUNT-HOLDER': string
  'ALTERNATE-ADDRESS': string
  'THIRD-PARTY': string
}
export type RecipientTypes = keyof Recipients
export const RecipientTypeText = {
  'ACCOUNT-HOLDER': 'Account Holder',
  'ALTERNATE-ADDRESS': 'Alternate Address',
  'THIRD-PARTY': ' Third Party'
}

interface DeliveryMethods {
  STANDARD: string
  OVERNIGHT: string
  OVERNIGHT_TO_APEX: string
}
export type DeliveryMethodTypes = keyof DeliveryMethods | ''
export const deliveryMethodText = {
  STANDARD: 'Standard',
  OVERNIGHT: 'Overnight',
  OVERNIGHT_TO_APEX: 'Overnight to Apex'
}

export type DistributionReasonTypes = DistributionReason | ''

export interface CheckTransferValues {
  fromAccount: string
  transferAmountDisplay: string
  totalBalanceCheckbox: boolean
  transferAmountRaw: number
  sendTo: RecipientTypes
  beneficiaryName: string
  recipientAddress: string
  recipientAddressLine2: string
  recipientCity: string
  recipientState: string
  recipientZip: string
  recipientCountry: string
  deliveryMethod: DeliveryMethodTypes
  memo1?: string
  memo2?: string
  memo3?: string
  contributionYear?: string
  distributionReason?: DistributionReasonTypes
  federalTaxWithholdingType: TaxWithholdingTypes
  federalTaxWithholdingAmountDisplay: string
  federalTaxWithholdingAmountRaw: number
  stateTaxWithholdingType: TaxWithholdingTypes
  stateTaxWithholdingAmountDisplay: string
  stateTaxWithholdingAmountRaw: number
  receivingInstitutionName?: string
  transferRecurrence: keyof TransferRecurrences
  whenToSend: keyof WhenToSend
  transferScheduledDate: string | Date
  transferStartDate: string | Date
  transferFrequency?: keyof TransferFrequency
  numberOfTransfers?: number
  frequencyUnit?: RecurringTransferFrequency
  frequencyInterval?: RecurringTransferFrequency
  startDate?: Date
  hasTotalDistributionError?: boolean
  fees: TransferFeesType
  optOutFormProvided?: boolean
}
